require('./hierarchytree.scss')
const hierarchyIcons = require('./hierarchyIcons.js')
const _ = require('lodash')

var angular = require('angular')
angular.module('promemoria').component('auiHierarchyTree', {
  template: require('./hierarchytree.html'),
  bindings: {
    parentPath: '@',
    baseUrl: '@',
    table: '@?',
    include: '<',
    onLoaded: '&'
  },
  controller: ['$http', 'ENDPOINT_AGGREGATE', function ($http, ENDPOINT_AGGREGATE) {
    var ctrl = this
    this._ = _
    this.table = this.table || 'ca_objects'
    this.getChildren = function (node) {
      if (!node.children) {
        node.loading = true
        return getItems(node.id).then(function (response) {
          node.children = setIcon(_.head(response.data.data).children)
          node.expansed = true
          node.loading = false
          return node.children
        })
      } else {
        node.expansed = !node.expansed
      }
    }
    // INIT
    getItems(0).then(function (response) {
      ctrl.children = setIcon(_.head(response.data.data).children)
      if (ctrl.include) {
        ctrl.children = _.filter(ctrl.children, function (item) {
          return _.indexOf(ctrl.include, item.id) > -1
        })
      }
      if (ctrl.parentPath) {
        var parentIds = _.split(ctrl.parentPath, '/')
        parentIds = _.map(parentIds, (item) => parseInt(item))
        getItems(parentIds).then(function (response) {
          var dati = response.data.data
          _.reduce(parentIds, function (children, parentId) {
            var item = _.find(dati, { _id: parentId })
            var found = _.find(children, { id: parentId })
            found.children = setIcon(item.children)
            found.expansed = true
            return found.children
          }, ctrl.children)
        })
      }
      ctrl.onLoaded()
    })

    // private
    function setIcon (children) {
      return _.map(children, function (node) {
        node.icon = hierarchyIcons.getIcon(node.type)
        return node
      })
    }
    function getItems (ids) {
      return $http.post(ENDPOINT_AGGREGATE, {
        'table': 'data',
        'query': [
          {
            '$match': {
              'parent': _.isArray(ids) ? { '$in': ids } : ids,
              'access': {
                '$nin': [0]
              },
              'table': ctrl.table
            }
          },
          {
            '$group': {
              '_id': '$parent',
              'children': {
                '$push': {
                  'id': '$id',
                  'parent_id': '$parent',
                  'preferred_label': '$preferred_label',
                  'isChild': '$isChild',
                  'hasMedia': '$hasMedia',
                  'type': '$type_id.name'
                }
              }
            }
          }
        ]
      })
    }
  }]
})



// WEBPACK FOOTER //
// ./src/js/components/hierarchytree/hierarchytree.js